import { render, staticRenderFns } from "./AIVSelect.vue?vue&type=template&id=93b925c2&scoped=true"
import script from "./AIVSelect.vue?vue&type=script&lang=js"
export * from "./AIVSelect.vue?vue&type=script&lang=js"
import style0 from "./AIVSelect.vue?vue&type=style&index=0&id=93b925c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b925c2",
  null
  
)

export default component.exports